import React from 'react';
import {motion,AnimatePresence} from 'framer-motion';
import KeyboardButton from './KeyboardButton';
import {orderNames} from '../data/amharicData';
import SafeIcon from '../common/SafeIcon';
import *as FiIcons from 'react-icons/fi';

const {FiX}=FiIcons;

const ExplosionModal=({isOpen,onClose,consonantFamily,onCharacterSelect,highlightedIndex})=> {
  if (!consonantFamily) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Semi-transparent overlay that allows background to remain visible */}
          <motion.div
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={{opacity: 0}}
            className="fixed inset-0 bg-black/30 backdrop-blur-[2px] z-40"
            onClick={onClose}
          />
          
          {/* Modal positioned near left edge with proper expansion to the right */}
          <motion.div
            initial={{x: -100,opacity: 0,scale: 0.9}}
            animate={{x: 0,opacity: 1,scale: 1}}
            exit={{x: -100,opacity: 0,scale: 0.9}}
            transition={{type: "spring",bounce: 0.4}}
            className="fixed top-1/2 left-4 sm:left-8 transform -translate-y-1/2 bg-white rounded-2xl p-6 sm:p-8 shadow-2xl z-50 border-4 border-[#E63946] w-[85vw] sm:w-[75vw] max-w-3xl max-h-[80vh] overflow-y-auto"
            onClick={(e)=> e.stopPropagation()}
          >
            {/* Header */}
            <div className="flex justify-between items-center mb-6 border-b-2 border-[#E63946] border-opacity-30 pb-4">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 bg-gradient-to-br from-[#FF7043] to-[#D84315] rounded-2xl flex items-center justify-center text-4xl font-bold text-white shadow-xl">
                  {consonantFamily.base}
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900">Family {consonantFamily.base}</h3>
                  <p className="text-sm text-gray-700 font-medium">Select a form</p>
                </div>
              </div>
              <button 
                onClick={onClose} 
                className="p-3 bg-gray-100 hover:bg-[#E63946] hover:text-white text-gray-700 rounded-xl transition-all shadow-md"
              >
                <SafeIcon icon={FiX} className="text-xl" />
              </button>
            </div>

            {/* Spacious character grid */}
            <div className="grid grid-cols-4 sm:grid-cols-7 gap-4 sm:gap-6 justify-items-center">
              {consonantFamily.family.map((char,index)=> (
                <motion.button
                  key={index}
                  whileHover={{y: -2,scale: 1.05}}
                  whileTap={{scale: 0.95}}
                  onClick={()=> onCharacterSelect(char)}
                  className={`
                    w-16 h-20 sm:w-20 sm:h-24 rounded-2xl flex flex-col items-center justify-center gap-2 border-b-4 transition-all shadow-xl
                    ${highlightedIndex===index 
                      ? 'bg-[#E63946]/30 border-[#E63946] text-gray-900 ring-4 ring-[#E63946]/50 scale-105' 
                      : 'bg-white border-gray-400 text-gray-800 hover:border-[#FFD60A] hover:bg-[#FFD60A]/20'}
                  `}
                >
                  <span className="text-2xl sm:text-3xl font-bold">{char}</span>
                  <span className="text-[10px] sm:text-xs font-bold uppercase tracking-wider text-gray-600">
                    {orderNames[index].split(' ')[0]}
                  </span>
                </motion.button>
              ))}
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default ExplosionModal;